import { usePlan } from "@/components/ProBadge";

const DROPS_URL = "https://customer-assets-agu9un31.emergentagent.net/job_nutrifit-client-1/artifacts/1xx7d8jc_IMG_0496.webp";

/** Solano two-drops bubble overlaid on the dashboard avatar (top-left, per
    the user's mockup) — visible ONLY for Pro users as a subtle status
    symbol. Pointer-events off so the avatar's own tap target (photo
    upload) keeps working. */
export default function ProStatusBadge() {
  const plan = usePlan();
  if (plan?.plan !== "pro") return null;
  return (
    <span
      data-testid="pro-status-badge"
      title="Solano Essence Pro"
      className="pointer-events-none absolute -top-1.5 -left-1.5 z-10 h-6 w-6 rounded-full bg-white dark:bg-[#1a1d1e] flex items-center justify-center shadow-md border border-slate-200 dark:border-slate-700"
    >
      <img src={DROPS_URL} alt="Pro" className="h-4 w-4 object-contain" />
    </span>
  );
}
